import { render, staticRenderFns } from "./_rightPancake2.vue?vue&type=template&id=1b1aaf7d&scoped=true&"
import script from "./_rightPancake2.vue?vue&type=script&lang=js&"
export * from "./_rightPancake2.vue?vue&type=script&lang=js&"
import style0 from "./_rightPancake2.vue?vue&type=style&index=0&id=1b1aaf7d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1aaf7d",
  null
  
)

export default component.exports